import { ChangeEvent, KeyboardEventHandler, useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Props } from './input-checkbox-editable.type';

export const InputCheckboxEditable = ({ onChange, name, disabled, ...props }: Props) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);

  const [label, setLabel] = useState('');
  const [isEditable, setIsEditable] = useState(false);

  const handleChangeParent = () => {
    setIsEditable(false);

    if (label.length !== 0) {
      onChange(label);
      setLabel('');
    }
  };

  const handleSetIsEditable = () => {
    setIsEditable(true);
  };

  useLayoutEffect(() => {
    if (isEditable) ref.current?.focus();
  }, [isEditable]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setLabel(e.currentTarget.value);
  };

  const handleBlur = () => {
    handleChangeParent();
  };

  const handleKeypress: KeyboardEventHandler<HTMLInputElement> = (e) => {
    const { key } = e;

    if (key === 'Enter') {
      handleChangeParent();
    }
  };

  return (
    <div className='flex items-center min-w-max'>
      {!isEditable && (
        <>
          <button
            className={classNames('ml-3 text-subtitle-s', {
              'text-tertiary cursor-not-allowed pointer-events-none': disabled,
              'text-primary': !disabled,
            })}
            onClick={() => !disabled && handleSetIsEditable()}
            disabled={disabled}>
            + {t('common:addRequirement')}
          </button>
        </>
      )}

      {isEditable && (
        <>
          <label htmlFor={name} className='sr-only'>
            + {t('common:addRequirement')}
          </label>
          <input
            {...props}
            ref={ref}
            name={name}
            type='text'
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyPress={handleKeypress}
            className='ml-3 w-full p-1
              bg-primary
              border-0 border-b border-medium focus:border-hard hover:border-hard
              text-primary text-body-s placeholder:text-secondary placeholder:text-body-s
              focus:outline-hidden focus:ring-0 '
          />
        </>
      )}
    </div>
  );
};
